export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_ac4f3722-13ff-4726-9fc6-2af273c13a78/artifacts/0f2pgus7_IMG_20261003_175513.webp";

export const DEFAULT_SETTINGS = {
  phone: "+91 94242 66166",
  whatsapp: "919424266166",
  email: "hello@uniqueorganicfarm.com",
  address: "Unique Organic Farm, Chhattisgarh, India",
  maps_url: "https://goo.gl/maps/eqVSEGuYYNwvGoxR7?g_st=ac",
  maps_embed:
    "https://maps.google.com/maps?q=21.794210,82.231898&z=14&output=embed",
  instagram: "#",
  facebook: "#",
  youtube: "#",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Spices", id: "spices" },
  { label: "Fruits", id: "fruits" },
  { label: "Nursery", id: "nursery" },
  { label: "Farm Story", id: "farm-story" },
  { label: "Contact", id: "contact" },
];

export const CATEGORIES = [
  { key: "spices", num: "01", label: "Spices" },
  { key: "fruits", num: "02", label: "Fruits" },
  { key: "nursery", num: "03", label: "Nursery" },
  { key: "vegetables", num: "04", label: "Dried Vegetables" },
];

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(el, { offset: -64, duration: 1.5 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function telLink(settings) {
  return `tel:${(settings.phone || "").replace(/[^+\d]/g, "")}`;
}

export function waLink(settings, productName) {
  const msg = productName
    ? `Hello Unique Organic Farm, I am interested in ${productName}. Please share availability and details.`
    : "Hello Unique Organic Farm, I would like to know more about your products. Please share availability and details.";
  return `https://wa.me/${settings.whatsapp}?text=${encodeURIComponent(msg)}`;
}
